// extracted by mini-css-extract-plugin
export default {"like":"_2EfEg","not-clickable":"_8Q1qr","notClickable":"_8Q1qr","likebutton":"_2AJ17","likes":"_17IF8"};